// import request from "@/utils/request";


// // 获取消息来源
// export function getSourceOfMessage() {
//   return request({
//     url: `${API}api/proxy/message/api/send/system/log/system/list`,
//     method: "get"
//   });
// }

// // 获取未读消息
// export function getUnreadMessageList(keywords, pageIndex, source) {
//   return request({
//     url: `${API}api/proxy/message/api/send/system/log/remind/not?paramsMap%5Bkeywords%5D=${keywords}&pageIndex=${pageIndex}&itemsPerPage=20&paramsMap%5Bapplication%5D=${source}`,
//     method: "get"
//   });
// }

// // 获取已读消息
// export function getReadMessageList(keywords, pageIndex, source) {
//   return request({
//     url: `${API}api/proxy/message/api/send/system/log/remind/have?paramsMap%5Bkeywords%5D=${keywords}&pageIndex=${pageIndex}&itemsPerPage=20&paramsMap%5Bapplication%5D=${source}`,
//     method: "get"
//   });
// }

// // 获取回收站消息
// export function getDelMessageList(keywords, pageIndex, source) {
//   return request({
//     url: `${API}api/proxy/message/api/send/system/log/remind/delFlag?paramsMap%5Bkeywords%5D=${keywords}&pageIndex=${pageIndex}&itemsPerPage=20&paramsMap%5Bapplication%5D=${source}`,
//     method: "get"
//   });
// }

// // 标记为已读
// export function markAsRead(ids) {
//   return request({
//     url: `${API}api/proxy/message/api/send/system/log/read?ids=${ids}`,
//     method: "post"
//   });
// }

// // 标记为未读
// export function markAsUnead(ids) {
//   return request({
//     url: `${API}api/proxy/message/api/send/system/log/unread?ids=${ids}`,
//     method: "post"
//   });
// }

// // 标记为已读或未读
// export function markAll(status) {
//   return request({
//     url: `${API}api/proxy/message/api/send/system/log/system/signReadStatus?read=${status}`,
//     method: "post"
//   });
// }

// // 删除消息
// export function delMessage(ids) {
//   return request({
//     url: `${API}api/proxy/message/api/send/system/log/delete?ids=${ids}`,
//     method: "post"
//   });
// }

// // 恢复删除消息
// export function recovery(ids) {
//   return request({
//     url: `${API}api/proxy/message/api/send/system/log/cancelDelete?ids=${ids}`,
//     method: "post"
//   });
// }

// // 彻底删除消息
// export function realDelMessage(ids) {
//   return request({
//     url: `${API}api/proxy/message/api/send/system/log/realDelete?ids=${ids}`,
//     method: "post"
//   });
// }

// // 获取配置列表
// export function getMessageConfigList() {
//   return request({
//     url: `${API}api/proxy/message/api/accept/list?loadAll=true`,
//     method: "get"
//   });
// }

// // 消息中心 - 保存配置
// export function saveMessageConfig(data) {
//   return request({
//     url: `${API}api/proxy/message/api/accept/updateEnabled`,
//     method: "post",
//     data: data
//   });
// }

import request from '@/utils/request';
import configR from '@/configs.js';
const API = configR.envConfigs.PORTAL_API;
// 以上为演示版门户 以下为新接口
// 获取未读消息列表接口
export function getUnreadedMessageList(data) {
  return data.request({
    url: `${data.serveUrl}api/v1/messageCenter/listMessageRecord`,
    method: "get",
    params: data.params,
    headerType: data.header
  });
}
// 获取未读消息数量
export function getUnreadedMessageCount(params) {
  return request({
    url: `${configR.envConfigs.MESSAGE_API_URL}center/api/v1/messageCenter/listMessageRecordIsReadCount`,
    method: "get",
    params: params,
    headerType: "message"
  });
}
// 获取未读消息数量
export function getListMessageRecordCount(params) {
  return request({
    url: `${configR.envConfigs.MESSAGE_API_URL}center/api/v1/messageCenter/listMessageRecordCount`,
    method: "get",
    params: params,
    headerType: "message"
  });
}
// 消息搜索
export function saveInformations(param) {
  return request({
    url: `${API}v1/search/saveInformations`,
    method: "post",
    headerType: "portal",
    params:param
  });
}
